import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "dataTables_wrapper dt-bootstrap4 no-footer" }
const _hoisted_2 = { class: "table-responsive" }
const _hoisted_3 = {
  class: "table align-middle table-row-bordered table-hover fs-6 dataTable no-footer",
  role: "grid"
}
const _hoisted_4 = {
  class: "text-start text-gray-500 fw-bold text-uppercase gs-0",
  role: "row"
}
const _hoisted_5 = {
  key: 0,
  class: "text-start w-25px"
}
const _hoisted_6 = ["onClick", "colspan"]
const _hoisted_7 = { class: "fw-bold text-gray-800" }
const _hoisted_8 = {
  key: 0,
  class: "text-start"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = {
  key: 1,
  class: "cell-btn w-40px"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "svg-icon svg-icon-3 icon-minus" }
const _hoisted_14 = { class: "svg-icon svg-icon-3 icon-plus" }
const _hoisted_15 = {
  key: 0,
  class: "total-tr"
}
const _hoisted_16 = ["colspan", "innerHTML"]
const _hoisted_17 = ["colspan", "innerHTML"]
const _hoisted_18 = ["colspan", "innerHTML"]
const _hoisted_19 = {
  key: 2,
  class: "subtable_template"
}
const _hoisted_20 = ["colspan"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = ["colspan"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "row mt-4" }
const _hoisted_25 = { class: "table-meta-info col-sm-12 col-md-5 ps-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_26 = {
  key: 0,
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<option value=\"10\">10</option><option value=\"30\">30</option><option value=\"50\">50</option><option value=\"100\">100</option><option value=\"200\">200</option>", 5)
const _hoisted_32 = [
  _hoisted_27
]
const _hoisted_33 = { class: "number" }
const _hoisted_34 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_35 = {
  key: 0,
  class: "overlay-layer card-rounded bg-dark bg-opacity-5"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_37 = [
  _hoisted_36
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_4, [
            (_ctx.selection)
              ? (_openBlock(), _createElementBlock("th", _hoisted_5, [
                  _createElementVNode("label", {
                    class: "form-check form-check-sm form-check-custom form-check-solid",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleAllSelect && _ctx.toggleAllSelect(...args)), ["stop"]))
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isAllChecked) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.isAllChecked]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (cell, i) => {
              return (_openBlock(), _createElementBlock("th", {
                key: i,
                onClick: ($event: any) => (
                  _ctx.sort(
                    cell.sortingField ? cell.sortingField : cell.key,
                    cell.sortable
                  )
                ),
                class: _normalizeClass([
                  cell.sortable !== false && 'sorting',
                  _ctx.currentSort ===
                    `${cell.sortingField ? cell.sortingField : cell.key}desc` &&
                    'sorting_desc',
                  _ctx.currentSort ===
                    `${cell.sortingField ? cell.sortingField : cell.key}asc` &&
                    'sorting_asc',
                  cell.align == 'left' && 'text-start',
                  cell.align == 'center' && 'text-center',
                  cell.align == 'right' && 'text-end',
                  cell.key == 'actions' && 'text-end',
                ]),
                tabindex: "0",
                rowspan: "1",
                colspan: cell.key == 'actions' && _ctx.showExpandBtn ? 2 : 1,
                style: _normalizeStyle({
                  cursor: cell.sortable !== false ? 'pointer' : 'default',
                  ...(cell.offset
                    ? {
                        [cell.align === 'right'
                          ? 'padding-right'
                          : 'padding-left']: `${cell.offset}`,
                      }
                    : {}),
                })
              }, _toDisplayString(cell.name), 15, _hoisted_6))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", _hoisted_7, [
          (_ctx.getItems.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.getItems, (item, i) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                  _createElementVNode("tr", {
                    class: _normalizeClass({ active: i == _ctx.trIndex })
                  }, [
                    (_ctx.selection)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
                          _createElementVNode("label", {
                            class: "form-check form-check-sm form-check-custom form-check-solid",
                            onClick: _withModifiers(($event: any) => (_ctx.toggleRowSelect(i)), ["stop"])
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              "onUpdate:modelValue": ($event: any) => ((item.isChecked) = $event)
                            }, null, 8, _hoisted_10), [
                              [_vModelCheckbox, item.isChecked]
                            ])
                          ], 8, _hoisted_9)
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (cell, i) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: i,
                        class: _normalizeClass([
                      item.sortable !== false && 'sorting',
                      cell.align == 'left' && 'text-start',
                      cell.align == 'center' && 'text-center',
                      cell.align == 'right' && 'text-end',
                      cell.key == 'actions' && 'text-end',
                    ]),
                        style: _normalizeStyle(
                      cell.offset
                        ? {
                            [cell.align === 'right'
                              ? 'padding-right'
                              : 'padding-left']: `${cell.offset}`,
                          }
                        : {}
                    )
                      }, [
                        _renderSlot(_ctx.$slots, `cell-${cell.key}`, { row: item }, () => [
                          _createTextVNode(_toDisplayString(item[_ctx.prop]), 1)
                        ])
                      ], 6))
                    }), 128)),
                    (_ctx.showExpandBtn)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                          _createElementVNode("button", {
                            class: _normalizeClass(["btn btn-icon toggle-btn btn-bg-light btn-active-color-primary btn-sm", { active: item.isExpand }]),
                            onClick: _withModifiers(($event: any) => (_ctx.onToggleBtnClick(i)), ["stop"])
                          }, [
                            _createElementVNode("span", _hoisted_13, [
                              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr090.svg" })
                            ]),
                            _createElementVNode("span", _hoisted_14, [
                              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr075.svg" })
                            ])
                          ], 10, _hoisted_12)
                        ]))
                      : _createCommentVNode("", true)
                  ], 2),
                  (_ctx.totalArray.length > 0)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.totalArray, (t, k) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                          (
                      t.string.length === _ctx.colspanNumber &&
                      t.string.length === t.span.length &&
                      t.index === i
                    )
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                                (_ctx.selection && t.span[0] !== 0)
                                  ? (_openBlock(), _createElementBlock("td", {
                                      key: 0,
                                      class: "text-start",
                                      colspan: t.span[0],
                                      innerHTML: t.string[0]
                                    }, null, 8, _hoisted_16))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (cell, i) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                                    (t.span[i + 1] !== 0)
                                      ? (_openBlock(), _createElementBlock("td", {
                                          key: 0,
                                          class: _normalizeClass([
                          item.sortable !== false && 'sorting',
                          cell.align == 'left' && 'text-start',
                          cell.align == 'center' && 'text-center',
                          cell.align == 'right' && 'text-end',
                          cell.key == 'actions' && 'text-end',
                        ]),
                                          colspan: t.span[i + 1],
                                          innerHTML: t.string[i + 1]
                                        }, null, 10, _hoisted_17))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 128)),
                                (_ctx.showExpandBtn && t.span[t.span.length - 1] !== 0)
                                  ? (_openBlock(), _createElementBlock("td", {
                                      key: 1,
                                      colspan: t.span[t.span.length - 1],
                                      class: "cell-btn w-40px",
                                      innerHTML: t.string[t.string.length - 1]
                                    }, null, 8, _hoisted_18))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    : _createCommentVNode("", true),
                  (_ctx.sameTable && item.isExpand)
                    ? _renderSlot(_ctx.$slots, "cell-sub", {
                        key: 1,
                        row: item
                      })
                    : _createCommentVNode("", true),
                  (!_ctx.sameTable && item.isExpand)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                        _createElementVNode("td", { colspan: _ctx.colspanNumber }, [
                          _renderSlot(_ctx.$slots, "cell-sub", { row: item })
                        ], 8, _hoisted_20)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            : (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                _createElementVNode("td", {
                  colspan: _ctx.colspanNumber,
                  class: "dataTables_empty"
                }, [
                  _createElementVNode("p", null, [
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.emptyTableText), 1))
                      : _createCommentVNode("", true)
                  ])
                ], 8, _hoisted_22)
              ]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        (_ctx.enableItemsPerPageDropdown)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pagination.rowsPerPage) = $event)),
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.setItemsPerPage && _ctx.setItemsPerPage(...args)))
                }, _hoisted_32, 544), [
                  [_vModelSelect, _ctx.pagination.rowsPerPage]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.translate("common.records", [
              _ctx.rowsStartNumber,
              _ctx.rowsEndNumber,
              _ctx.pagination.total,
            ])), 1)
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createVNode(_component_el_pagination, {
          "current-page": _ctx.pagination.page,
          "onUpdate:current-page": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pagination.page) = $event)),
          onCurrentChange: _ctx.currentPageChange,
          "page-size": _ctx.pagination.rowsPerPage,
          "pager-count": _ctx.isMobile ? 5 : 7,
          layout: "prev, pager, next",
          total: _ctx.pagination.total,
          "hide-on-single-page": true,
          background: ""
        }, null, 8, ["current-page", "onCurrentChange", "page-size", "pager-count", "total"])
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_37))
      : _createCommentVNode("", true)
  ]))
}